export let ammo = null;

export async function loadAmmo() {
  ammo = await Ammo();
}

export { ammo as default };
